import React from 'react'
import PropTypes from 'prop-types'
import styles from './FileCountBadge.scss'
import { Badge, Tooltip } from 'reactstrap'

const FileCountBadge = props =>
  <div className={styles.FileCountBadge}>
    {
      !props.isTestEnv &&
      <Tooltip placement='top' isOpen={props.isTooltipOpen} target={props.uid} toggle={props.toggle}>
        Count includes appearances in draft and published.
      </Tooltip>
    }
    <Badge id={props.uid}>{props.count}</Badge>
  </div>

FileCountBadge.propTypes = {
  count: PropTypes.number,
  uid: PropTypes.string,
  isTooltipOpen: PropTypes.bool,
  isTestEnv: PropTypes.bool,
  toggle: PropTypes.func
}

export default FileCountBadge



// WEBPACK FOOTER //
// ./src/components/FileCountBadge/FileCountBadge.js